import './GraphQuantityCenterComponent.scss';
import React, { Component } from 'react';
import { Card } from 'react-bootstrap';
import Axios from 'axios';

class GraphQuantityCenterComponent extends Component {
	state = {
		data : 0
	};

	constructor(props) {
		super(props);
	}

	async componentDidMount() {
		let data = await this.getQuantityData();
		this.setState({
			data: data
		});
	}

	async getQuantityData(){
		return Axios.get(process.env.REACT_APP_API_STATISTICS_URL + '/v1/center/count', {
			responseType: 'json',
		})
		.then((response) => {
			return response.data.data;
		});
	}

	render() {
		return (
			<div>
				<Card.Header>Centros activos</Card.Header>
				<Card className='mb-2' border='primary'>
					<Card.Body>
						<h1>{this.state.data}</h1>
					</Card.Body>
				</Card>
			</div>
		);
	}
}

export default GraphQuantityCenterComponent;